import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-lift-parameter-filter',
  templateUrl: './lift-parameter-filter.component.html',
  styleUrls: ['./lift-parameter-filter.component.css']
})
export class LiftParameterFilterComponent {

  @Output()
  onSearch = new EventEmitter<string>();

  searchBox = new FormControl();

  constructor() {
    this.searchBox
      .valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged()
      ).subscribe(term => {
        this.onSearch.emit(term);
      });
  }

}
